import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import DetailRepository from '../Repositories/IndexRepository'


class IndexBloc {

    acDataChannel = new Subject();
    acDetailChannel = new Subject();
    stankomChannel = new Subject();
    acMatrixChannel = new Subject();
    searchMatrixChannel = new Subject();
    devGuideChannel = new Subject();
    periodChannel = new Subject();
    eselonChannel = new Subject();
    positionChannel = new Subject();
    SuitablePossitionChannel = new Subject();
    mxListChannel = new Subject();
    searchJpmChannel = new Subject();
    repository = new DetailRepository()

    constructor() {
        this.acDataChannel.next({status: apiResponse.INITIAL})
        this.acDetailChannel.next({status: apiResponse.INITIAL})
        this.stankomChannel.next({status: apiResponse.INITIAL})
        this.SuitablePossitionChannel.next({status: apiResponse.INITIAL})
        this.mxListChannel.next({status: apiResponse.INITIAL})
        this.searchJpmChannel.next({status: apiResponse.INITIAL})
    }

    fetchAcData = async (query) => {
       try {
           this.acDataChannel.next({status: apiResponse.LOADING})
           await this.repository.fetchAcData(query).then((result) => {
               this.acDataChannel.next({status: apiResponse.COMPLETED, data: result})
           }).catch((error) => {
               this.acDataChannel.next({status: apiResponse.ERROR, data: error})
           })
       } catch (error) { console.log("unsubscribed")}
    }
    fetchAcDetail = async (query) => {
        this.acDetailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchAcDetail(query).then((result) => {
            this.acDetailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.acDetailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchStankom = async (query) => {
        this.stankomChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchStankom(query).then((result) => {
            this.stankomChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.stankomChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchMatrix = async (query) => {
        this.acMatrixChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMatrix(query).then((result) => {
            this.acMatrixChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.acMatrixChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchSearch = async (query) => {
        this.searchMatrixChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSearch(query).then((result) => {
            this.searchMatrixChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.searchMatrixChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchDevGuide = async (query) => {
        this.devGuideChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDevGuide(query).then((result) => {
            this.devGuideChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.devGuideChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchSuitablePossision = async (query) => {
        this.SuitablePossitionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSuitablePossision(query).then((result) => {
            this.SuitablePossitionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.SuitablePossitionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchPeriod = async (query) => {
        this.periodChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPeriod(query).then((result) => {
            this.periodChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.periodChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchEselon = async (query) => {
        this.eselonChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchEselon(query).then((result) => {
            this.eselonChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.eselonChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchPosition = async (query) => {
        this.positionChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchPosition(query).then((result) => {
            this.positionChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.positionChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchMatrixassesmentlist = async (query) => {
        this.mxListChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchMatrixassesmentlist(query).then((result) => {
            this.mxListChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.mxListChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchSearchJpm = async (query) => {
        this.searchJpmChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchSearchJpm(query).then((result) => {
            this.searchJpmChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.searchJpmChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
}

export default IndexBloc